<template>
  <div class="system-menu-container">
    <!-- TAB 切换栏 -->
    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
      <el-tab-pane label="菜单管理" name="menu" />
      <el-tab-pane label="按钮管理" name="button" />
      <el-tab-pane label="角色管理" name="role" />
      <el-tab-pane label="角色授权" name="roleAuth" />
      <el-tab-pane label="业务菜单授权" name="businessAuth" />
    </el-tabs>

    <!-- 动态渲染子组件 -->
    <div class="tab-content">
      <!-- 1. 菜单管理 -->
      <MenuTable v-if="activeTab === 'menu'" ref="menuTable" />

      <!-- 2. 按钮管理 -->
      <ButtonTable v-if="activeTab === 'button'" ref="buttonTable" />

      <!-- 3. 角色管理 -->
      <RoleTable v-if="activeTab === 'role'" ref="roleTable" />

      <!-- 4. 角色菜单授权 -->
      <RoleAuth v-if="activeTab === 'roleAuth'" ref="roleAuth" />

      <!-- 5. 业务菜单授权 -->
      <BusinessAuth v-if="activeTab === 'businessAuth'" ref="businessAuth" />
    </div>
  </div>
</template>

<script>
// 导入所有子组件
import MenuTable from './components/MenuTable'
import ButtonTable from './components/ButtonTable'
import RoleTable from './components/RoleTable'
import RoleAuth from './components/RoleAuth'
import BusinessAuth from './components/BusinessAuth'

export default {
  name: 'MenuIndex',
  components: {
    MenuTable,
    ButtonTable,
    RoleTable,
    RoleAuth,
    BusinessAuth
  },
  data() {
    return {
      activeTab: 'menu' // 默认显示菜单管理
    }
  },
  methods: {
    // TAB 切换事件
    handleTabClick(tab) {
      this.activeTab = tab.name
    }
  }
}
</script>

<style scoped>
.system-menu-container {
  padding: 20px;
}
.tab-content {
  margin-top: 20px;
}
</style>